import { useState, useEffect } from 'react';
import { atom, useAtom } from'jotai';
import styled from '@emotion/styled';
// import NoLoginPage from 'components/layout/newOnboarding/NoLogInPage';
import NoLoginPage from 'components/layout/newOnboarding/NoLogInPage';


import { Button, Toast } from 'components/ui';

import PhotoContainer from './PhotoContainer';
import ConfirmationModal from "./Modal/ComfirmModal";
import { selectedImagesAtom } from 'components/pages/onboardingNew/newOnboardingAtom';
// import { selectedImagesAtom } from 'components/pages/Onboarding/onboardingAtom';
import ReactGA from "react-ga4";

const showModalAtom = atom<boolean>(false); //전송 확인 모달창 열림 여부 상태

const Elem:React.FC<any> = ({ children }) => {
  const [ selectedImage, setSelectedImage ] = useAtom(selectedImagesAtom);
  const [ toastMessage, settoastMessage ]   = useState<string>("");
  const [ isToastOpen, setIsToastOpen ]     = useState<boolean>(false);
  const [ showModal, setShowModal ]         = useAtom(showModalAtom);


  const gaId = process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID;
  
  useEffect(() => {
    handleToast()
  }, [selectedImage]);

  const handleToast = () => {
    if (selectedImage.length < 5) {
      settoastMessage("5장의 사진을 모두 채워주세요!");
      setIsToastOpen(true);
    } else if (selectedImage.length > 5) {
      settoastMessage("초과된 사진은 자동으로 제외했어요!");
      setIsToastOpen(true);
    } else {
      settoastMessage("5장을 선택했어요!");
      setIsToastOpen(true);
    } 
  };

  const closeModal = () => {
    if (showModal === true) return setShowModal(false);
    ReactGA.event({
      "category": "Modal",
      "action" : "Close",
      "label"  : "photo confirm Modal"
    })
  };

  const handleCloasToast = () => {
    setIsToastOpen(false);
  };

  const handleResponse = () => {
    if (selectedImage.length >=5) {
      // ReactGA.event({
      //   category : "Button",
      //   action : "Open",
      //   label : "free photo confirm & send",
      //   value: 1
      // })
      setShowModal(true);
    } else {
      // 불필요한 이벤트로 헷갈림으로 인한 삭제
      // ReactGA.event({
      //   category : "Button",
      //   action : "Open",
      //   label : "photo confirm Modal",
      //   value: 2
      // })
      settoastMessage("사진을 먼저 추가하세요!");
      setIsToastOpen(true);
    }
  };

  useEffect(() => {
    if (gaId) {
      const user = localStorage.getItem('name');
      const previousUrl = document.referrer;
      ReactGA.set({
        referrer: previousUrl,
        userId:user
      })
      // ReactGA.send({ hitType: "pageview", page:"/onboarding/1/freekit", title: "send free kit" })
    }
  },[])

  useEffect(() => {
    setIsToastOpen(false)
  }, [])

  return (
    <NoLoginPage disable={false}>
      <Container>
        <TopContainer>
          <TextContainer>
            <SmallText>지금 인화하세요!</SmallText>
            <BigText className="Bottom">가장 소중한 사진 
              <br/>5장을 선택해 주세요.
            </BigText>
            <SmallText className="small">얼마나 쉬운지 경험해보세요.</SmallText>
          </TextContainer>
          <PhotoSelectContainer>
            <PhotoContainer />
          </PhotoSelectContainer>
        </TopContainer>
        <ButtonWrapper>
          <ToastContainser>
            {isToastOpen && 
              <Toast 
              message={toastMessage}
              onClose={handleCloasToast}
            />}
          </ToastContainser>
        
          <SendingButton
            onClick={handleResponse}
          >
            전송하기
          </SendingButton>
          {showModal && <ConfirmationModal showModal={showModal} closeModal={closeModal} />}
        </ButtonWrapper>
      </Container>
    </NoLoginPage>
  );
};

export default Elem;

const Container = styled.div`
  width: 100%;
  /* height: 100%; */
  height: 85vh;
  display: flex;
  flex-direction: column;
  background-color: #F5F3EF;
  padding: 20px 17px;
  overflow: auto;
`;

const TextContainer = styled.div`
  width: 267px;
  /* height: 87px; */
  display: flex;
  flex-direction: column;
`;

const SmallText = styled.div`
  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 700;
  font-size: 13px;
  line-height: 100%;
  color: #141414;
  margin-bottom: 15px;

    @media (max-width:321px) {
    font-size: 10px;
  }

  &.small{
    font-size: 12px;
    font-weight: 300;
    margin-top: 16px;
    margin-bottom: 0;
    line-height: 3%;
    color: rgba(117, 117, 117, 1);
  }
`;


const BigText = styled.div`
  font-family: 'Pretendard';
  font-style: normal;
  font-size: 24px;
  color: #141414;
    @media (max-width:321px) {
    font-size: 20px;
  }


  &.Top {
    font-size: 25px;
    font-weight: 300;
    margin-bottom: 5px;
  }

  &.Bottom {
    font-weight: Bold;
    line-height: 30px;
    letter-spacing: -0.03em;
  }
`;
const PhotoSelectContainer = styled.div`
  width: 100%;
  /* min-height: 550px; */
  margin: 49.32px auto 0;

  @media (max-width: 321px) {
    min-height: 450px;
  }
`;

const ButtonWrapper =styled.div`
  /* max-width: 320px; */
  width: 100%;
  @media (max-width:321px) {
    width: 87%;
  }
  height: 52px;
  /* display: flex; */
  margin: 80px auto 0;
`;

const ToastContainser = styled.div`
  max-width: 300px;
  width: 80%;
  height: 43px;
  margin: 0 auto 10px;
  position: relative;

  @media (max-width:321px) {
    margin-top: 0;
  }
`;

const TopContainer = styled.div`
  
`
const SendingButton = styled.button`
  width: 100%;
  height: 100%;
  background-color: #DBC6A7;
  border-radius: 30px;
  color: white;
`